import type { User } from '../../../types/api.types'
import type { ShiftResponse } from '../types/shift.types'

export function isEligibleManager(user: User | null, propertyId: number | null): boolean {
  if (!user || propertyId === null) return false
  return user.role === 'MANAGER' && user.property_ids.includes(propertyId)
}

export function isShiftOwner(user: User | null, shift: ShiftResponse | null): boolean {
  if (!user || !shift) return false
  return shift.supervisor_user_id === user.id
}

export function canForceClose(user: User | null): boolean {
  return user?.role === 'SUPER_ADMIN'
}

export function isHandoffManager(user: User | null): boolean {
  return user?.role === 'MANAGER' || user?.role === 'SUPER_ADMIN'
}
